<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">會員管理 / 推播訊息</b-col>
      <b-col></b-col>
    </b-row>
    <div id="func-content">
      <b-card class="bg-default-card" v-show="FunctionPermission >=2" >
        <div class="row">
          <div class="col-lg-12">
            <div class="p-4 box-shadow" header="Form Elements">
              <div class='table-responsive'>
                <div class='col-lg-12'>
                  <div class="form-group col-lg-12 p-10 row">
                    <label class="control-label">推播時間：</label>
                    <div class="col-lg-4">
                      <input type="date" class="form-control" v-model="pushDate" :min="today" max="9999-12-31" @change="checkPushTime">
                    </div>
                    <div class="col-lg-3">
                      <input type='time' class='form-control' v-model='pushTime' @change="checkPushTime">
                    </div>
                    <div class="text-danger" v-if="invalidDate">{{invalidDate}}</div>
                  </div>
                </div>
                <div class="col-lg-12 form-group">
                  <div class="col-lg-12 row">
                    <label class="control-label">推播標題：</label>
                    <div class="col-lg-8">
                      <input type="text" id="title" class="form-control" v-model.trim="pushTitle" @change="handleTitleChange" @input="checkLength" placeholder="字數限制30，建議10字以內使多數裝置可直接觀看">
                    </div>
                    <div class="text-danger" v-if="invalidTitle">{{invalidTitle}}</div>
                  </div>
                </div>
                <div class="col-lg-12 form-group">
                  <label class='control-label'>推播內容：</label>
                  <div class="col-lg-8 row">
                    <div class='col-md-9'>
                      <textarea id="content" v-model.trim="pushContent" rows="6" cols="70" @change="handleContentChange" @input="checkLength" placeholder="字數限制 200，建議 70 字以內所有手機才能顯示"></textarea>
                    </div>
                  </div>
                  <div class="text-danger" v-if="invalidContent">{{invalidContent}}</div>
                </div>
                <div class="col-lg-12">
                  <div class="col-lg-10 form-group row">
                    <div class='col-lg-3'>
                      <input type="radio" name="rdoType" v-model="pushType" value="1" @change="changePushType">
                      <label class='control-label'>單一會員</label>
                    </div>
                    <div class='col-lg-4'>
                      <input type="radio" name="rdoType" v-model="pushType" value="4" @change="changePushType">
                      <label class='control-label'>全部會員</label>
                    </div>
                  </div>
                  <div class="col-lg-10 form-group row">
                    <div class='col-lg-3'>
                      <input type="radio" name="rdoType" v-model="pushType" value="2" @change="changePushType">
                      <label class='control-label'>會員電話匯入</label>
                    </div>
                    <div class='col-lg-4'>
                      <input type="radio" name="rdoType" v-model="pushType" value="3" @change="changePushType">
                      <label class='control-label'>會員ID匯入</label>
                    </div>
                  </div>
                  <div class="col-lg-10 form-group row" v-if="pushType==1">
                    <div class="col-lg-4">
                      <input type='phone' maxlength="10" v-model='mobile' class='form-control' id='mobile' placeholder='請輸入會員電話' v-on:keyup="checkMobile($event)">
                    </div>
                    <div class="text-danger col-lg-4" v-if="invalidPhone">{{invalidPhone}}</div>
                  </div>
                  <div class="col-lg-4 form-group" v-if="pushType==2">
                    <div>
                      <i class="fa fa-question-circle" style="cursor: pointer;" @click="$refs.importFileDesc.show()"></i>
                      <input type="file" class="upload_input" id="memberList" accept=".csv" @change="handleFileUpload">
                    </div>
                    <div class="text-danger" v-if="importAmount>0">
                      匯入{{importAmount}}筆資料
                    </div>
                  </div>
                  <div class="col-lg-4 form-group" v-if="pushType == 3">
                    <div>
                      <i class="fa fa-question-circle" style="cursor: pointer;" @click="$refs.importFileDesc.show()"></i>
                      <input type="file" class="upload_input" id="memberIdList" accept=".csv" @change="handleFileUpload">
                    </div>
                    <div class="text-danger" v-if="importAmount>0">
                      匯入{{importAmount}}筆資料
                    </div>
                  </div>
                </div>
                <div class='row col-lg-10'>
                  <button type='button' class='btn btn-normal-ptc1 broder' @click='handleSubmit()'>建立推播</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <div class="p-4 box-shadow" header="Form Elements">
              <table id="mytable" class="table table-bordred table-striped mt-3 table-break">
                <thead>
                <tr>
                  <th width="8%">序號</th>
                  <th width="17%">建立時間</th>
                  <th width="17%">推播時間</th>
                  <th width="25%">推播標題</th>
                  <th width="11%">推播類型</th>
                  <th width="12%" class="text-center">推播內容</th>
                  <th width="10%">狀態</th>
                </tr>
                <tr v-for="v in datalist" :key="v.ID">
                  <td>{{v.ID}}</td>
                  <td>{{v.CreatedAt | formatDate}}</td>
                  <td>{{v.SendAt | formatDate}}</td>
                  <td>{{JSON.parse(v.Data).title}}</td>
                  <td>{{ getPushTarget(v.Type) }}</td>
                  <td class="text-center"><button v-b-tooltip.hover.top title="推播內容" class="btn-circle btn-circle-ptc1" @click="showFcmBody(JSON.parse(v.Data).body)"><span class="far fa-list-alt"></span></button></td>
                  <td>
                    {{ // 儘管顯示予用戶狀態只有四種，但不能直接使用大於小於eslint(目前版本)會報錯
                      (v.Status === -2) ? '錯誤' :
                      (v.Status === -1) ? '錯誤' :
                      (v.Status === 0) ? '處理中' :
                      (v.Status === 1) ? '處理中' :
                      (v.Status === 2) ? '處理中' :
                      (v.Status === 3) ? '待推播' :
                      (v.Status === 4) ? '已完成' :
                      (v.Status === 5) ? '已完成' :
                      (v.Status === 6) ? '已完成' : ''
                    }}
                  </td>
                  <td v-if="LoginUserID==1&&v.Status === 3"><button class="btn-circle btn-circle-ptc1" @click="showModal('Delete', v.ID, JSON.parse(v.Data).title)" v-if="LoginUserID==1&&v.Status === 3"><i class="fas fa-trash-alt" title="刪除"></i></button></td>
                </tr>
                </thead>
              </table>
              <div>
                <div class="row" style="padding: 0 1rem">
                  <b-pagination size="md" :total-rows="model1.totalrows" v-model="model1.currentPage" :per-page="model1.rows" @change="getMemberPushesList"></b-pagination>
                  <label style="margin:8px">{{model1.startRowNum}}到{{model1.endRowNum}}，總共 {{model1.totalrows}}筆</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <!-- 匯入檔案說明 -->
    <b-modal v-if="pushType == 2" ref="importFileDesc" hide-footer title="匯入檔說明">
      <pre class="mb-0" style="font-size:16px">
檔案格式
1. 僅限csv檔。
2. 檔名不限。

內容限制
1. 僅需輸入手機號碼。
2. 限定每行為10碼數字。
3. 不可有空行(含最後一行)。
4. 會員手機號碼筆數上限為十萬筆。
      </pre>
      <img src="/static/pushMemberImportSample.png" class="img-fluid"/>
    </b-modal>
    <b-modal v-if="pushType == 3" ref="importFileDesc" hide-footer title="匯入檔說明">
      <pre class="mb-0" style="font-size:16px">
檔案格式
1. 僅限csv檔。
2. 檔名不限。

內容限制
1. 僅需輸入會員ID。
2. 不可有空行(含最後一行)。
3. 會員ID筆數上限為十萬筆。
      </pre>
      <img src="/static/pushMemberByIdSample.png" class="img-fluid"/>
    </b-modal>
    <!-- 推播內容-->
    <b-modal ref="mdFcmBody" hide-footer size='lg' title="推播內容">
      <b-container fluid>
        <div class="row">
          <div class="col-lg-12">{{fcmBody}}
          </div>
        </div>
      </b-container>
    </b-modal>
    <b-modal ref="ModalDelete" hide-footer title="推播刪除">
      <div class="d-block text-center" style="margin-bottom: 12px;">
        確定要刪除推播「{{delName}}」？
      </div>
      <div class="d-block text-right">
        <b-btn variant="primary" @click="Delete()">確定</b-btn>
        <b-btn variant="secondary" @click="hideModalDelete">取消</b-btn>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'
import { mapGetters } from 'vuex'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
miniToastr.init()
Vue.use(ClientTable, {}, false)
export default {
  computed: mapGetters({
    // 取得 loading state
    loading: 'getLoading'
  }),
  data () {
    return {
      pushDate: '',
      pushTime: '',
      pushTitle: '',
      pushContent: '',
      pushType: '1',
      mobile: '',
      memberList: null,
      memberIdList: null,
      today: '',
      invalidDate: '',
      invalidTitle: '',
      invalidContent: '',
      invalidPhone: '',
      datalist: [],
      importAmount: 0,
      model1: {
        currentPage: 1,
        totalrows: 0,
        rows: 10,
        startRowNum: 0,
        endRowNum: 0
      },
      fcmBody: '',
      delId: '', // 刪除Id
      delName: '', // 刪除名稱
      LoginUserID: 0
    }
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
      var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
      var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds
    }
  },
  methods: {
    reset () {
      this.invalidDate = ''
      this.invalidContent = ''
      this.invalidTitle = ''
      this.invalidPhone = ''
      this.pushDate = ''
      this.pushTime = ''
      this.pushTitle = ''
      this.pushContent = ''
      this.pushType = '1'
      this.mobile = ''
      this.memberList = null
      this.memberIdList = null
      this.importAmount = 0
      this.getCurrentTime()
    },
    onlyResetFile () {
      this.importAmount = 0
      this.memberList = null
      this.memberIdList = null
      if (document.getElementById('memberList')==null) {
        document.getElementById('memberIdList').value = null
      } else {
        document.getElementById('memberList').value = null
      }
    },
    changePushType () {
      this.importAmount = 0
    },
    checkPushTime () {
      this.getCurrentTime()
      if (!this.pushDate) {
        this.invalidDate = '日期格式不正確'
      } else if (this.pushDate <= this.today) {
        if (this.pushDate === this.today) {
          if (this.pushTime < this.nowTime) {
            this.invalidDate = '推播時間不得小於系統時間'
          } else {
            this.invalidDate = ''
          }
        } else {
          this.invalidDate = '推播日期不得小於系統日'
        }
      } else {
        this.invalidDate = ''
      }
    },
    handleContentChange () {
      this.invalidContent = ''
    },
    handleTitleChange () {
      this.invalidTitle = ''
    },
    checkMobile (event) {
      var value = event.target.value
      if (!/^\+?[0-9]{10}$/.test(value)) {
        this.invalidPhone = '請輸入正確手機號碼格式'
      } else {
        this.invalidPhone = ''
      }
    },
    handleFileUpload: async function (e) {
      let invalid = false
      const file = e.target.files[0]
      if (file.size > 1024 * 1024 * 2 || file.name.slice(-4) !== '.csv') {
        miniToastr.error('請確認名單格式及會員筆數')
        invalid = true
      }
      const reader = new FileReader()
      reader.readAsText(file)
      const frdDoneEvent = await new Promise(resolve => { reader.onload = resolve })
      const rows = frdDoneEvent.target.result.split('\n')
      const maxMemberAmount = 100000 // 上限十萬筆
      this.importAmount = rows.length
      if (rows.length > maxMemberAmount) {
        miniToastr.error('請確認名單格式及會員筆數')
        invalid = true
      }
      if (invalid) {
        this.onlyResetFile()
      } else {
        this.memberList = file
        this.memberIdList = file
        miniToastr.success('檔案上傳成功')
      }
    },
    getMemberPushesList (currentPage) {
      this.$parent.Loading = true
      axios.post(API_URL + '/web/webGetMemberPushesList/v1', {
        toPage: currentPage,
        perPage: this.model1.rows
      }).then((response) => {
        switch (response.data.result) {
          case '0000':
            this.model1.totalrows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            this.datalist = response.data.memberPushesList
            this.model1.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.model1.rows * (this.model1.currentPage - 1) + 1
            this.model1.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.model1.rows > response.data.totalRows) ? response.data.totalRows : (this.model1.currentPage * this.model1.rows) >= response.data.totalRows ? response.data.totalRows : this.model1.currentPage * this.model1.rows
            break
          case '0006':
            this.$parent.logOut(true, true)
            break
          default:
            miniToastr.error(response.data.message, '獲取歷史推播失敗')
        }
        this.$parent.Loading = false
      }).catch((err) => {
        miniToastr.error('獲取歷史推播失敗', err)
        this.$parent.Loading = false
      })
    },
    getPushTarget(type){
      switch (type) {
        case 1:
          return '單一會員';
        case 2:
          return '會員電話匯入';
        case 3:
          return '會員ID匯入';
        case 4:
          return '全部會員';
        default:
          return '未知';
      }
    },
    handleSubmit () {
      this.checkPushTime() // use to recheck the time
      if (!this.checkData()) return
      // Confirm invalid field must be empty
      if (!(this.invalidDate === '' && this.invalidTitle === '' && this.invalidContent === '' &&
          ((this.invalidPhone === '' && this.pushType === '1') ||
          (this.memberList !== null && this.pushType === '2') ||
          (this.memberIdList !== null && this.pushType === '3') ||
          (this.pushType === '4')))) {
        miniToastr.error('建立推播失敗請檢查表單內容')
        return
      }
      if (this.$parent.Loading === true) {
        miniToastr.error('忙碌中請稍後再送出表單')
        return
      }
      const datetime = `${this.pushDate} ${this.pushTime}`
      const formatDate = new Date(datetime)
      const csvSendTime = this.pushDate.replace(/-/g, '') + this.pushTime.replace(':', '')
      if (this.pushType === '1') { // 單一會員電話推播
        this.$parent.Loading = true
        axios.post(API_URL + '/web/memberPushByPhone/v1', {
          sendTime: csvSendTime,
          mobile: this.mobile,
          title: this.pushTitle,
          content: this.pushContent
        }).then((res) => {
          switch (res.data.result) {
            case '0000' :
              miniToastr.success('推播建立成功')
              this.reset()
              this.getMemberPushesList(1)
              break
            case '0006':
              this.$parent.logOut(true, true)
              break
            default :
              miniToastr.error(res.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        }).catch((err) => {
          miniToastr.error('發生未知錯誤', err)
          this.$parent.Loading = false
        })
      } else if (this.pushType === '2' || this.pushType === '3') { // 檔案推播
        this.$parent.Loading = true
        const form = new FormData()
        form.append('sendTime', csvSendTime)
        form.append('title', this.pushTitle)
        form.append('content', this.pushContent)
        if (this.pushType === '2') {
          // 若選擇"會員電話匯入"，就傳送memberList
          form.append('memberList', this.memberList)
        } else if (this.pushType === '3') {
          // 若選擇"會員ID匯入"，就傳送memberIdList
          form.append('memberIdList', this.memberIdList)
        }
        // form.append('memberList', this.memberList)
        let postOK = false
        axios.post(API_URL + '/web/memberPushByCSVFile/v1', form).then((res) => {
          switch (res.data.result) {
            case '0000' :
              postOK = true
              miniToastr.success('推播建立成功')
              this.reset()
              this.getMemberPushesList(1)
              break
            case '0006':
              this.$parent.logOut(true, true)
              break
            default :
              miniToastr.error(res.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        }).catch((err) => {
          miniToastr.error('發生未知錯誤', err)
          this.$parent.Loading = false
        }).finally(() => {
          if (!postOK) {
            // 發生錯誤清空檔案
            this.onlyResetFile()
          }
          this.$parent.Loading = false
        })
      } else if (this.pushType === '4') {
        this.$parent.Loading = true
        axios.post(API_URL + '/web/memberPushToAll/v1', {
          sendTime: formatDate.toISOString(),
          title: this.pushTitle,
          content: this.pushContent
        })
          .then((res) => {
            switch (res.data.result) {
              case '0000' :
                miniToastr.success('推播建立成功')
                this.reset()
                this.getMemberPushesList(1)
                break
              case '0006':
                this.$parent.logOut(true, true)
                break
              default :
                miniToastr.error(res.data.message, '錯誤訊息')
            }
            this.$parent.Loading = false
          })
          .catch((err) => {
            miniToastr.error('發生未知錯誤', err)
            this.$parent.Loading = false
          })
      } else {
        miniToastr.error('未預期錯誤產生請聯絡管理員')
      }
    },
    checkData () {
      let valid = true
      if (this.pushDate.trim() === '' || this.pushTime.trim() === '') {
        this.invalidDate = '推播時間不得空白'
        valid = false
      }
      if (this.pushTitle.trim() === '') {
        this.invalidTitle = '推播標題不得空白'
        valid = false
      }
      if (this.pushContent.trim() === '') {
        this.invalidContent = '推播內容不得空白'
        valid = false
      }
      if (this.pushType === '1' && this.mobile.trim() === '') {
        this.invalidPhone = '會員電話不得空白'
        valid = false
      }
      if (this.pushType === '2' && this.memberList === null) {
        miniToastr.error('請上傳檔案')
        valid = false
      }
      if (this.pushType === '3' && this.memberIdList === null) {
        miniToastr.error('請上傳檔案')
        valid = false
      }
      if (this.pushType !== '1' && this.pushType !== '2' && this.pushType !== '3' && this.pushType !== '4') {
        miniToastr.error('推播對象類型異常')
        valid = false
      }
      if (Array.from(this.pushTitle).length > 30) {
        this.invalidTitle = '推播標題超出字數限制'
        valid = false
      }
      if (Array.from(this.pushContent).length > 200) {
        this.invalidTitle = '推播內容超出字數限制'
        valid = false
      }
      return valid
    },
    getCurrentTime () {
      const date = new Date()
      const year = date.getFullYear()
      const mon = '0' + (date.getMonth() + 1).toString()
      const day = date.getDate() < 10 ? '0' + date.getDate() : '' + date.getDate()
      const hour = date.getHours() < 10 ? '0' + date.getHours() : '' + date.getHours()
      const min = date.getMinutes() < 10 ? '0' + date.getMinutes() : '' + date.getMinutes()
      this.today = year + '-' + mon + '-' + day
      this.nowTime = hour + ':' + min
    },
    checkLength (event) {
      // Need to using this function to check the length of the text with emoji
      const input = event.target
      const max = (input.id === 'title') ? 30 : (input.id === 'content') ? 200 : 0
      const text = input.value
      const textArr = Array.from(text)
      if (textArr.length > max) {
        if (input.id === 'title') {
          this.pushTitle = textArr.slice(0, max).join('')
        } else if ((input.id === 'content')) {
          this.pushContent = textArr.slice(0, max).join('')
        }
      }
    },
    showFcmBody (item) {
      this.$refs.mdFcmBody.show()
      this.fcmBody = item
    },
    showModal (mode, id, name) {
      if (mode === 'Delete') {
        this.$refs.ModalDelete.show()
      }
      this.delId = id
      this.delName = name
    },
    hideModalDelete () {
      this.$refs.ModalDelete.hide()
    },
    Delete () {
      this.hideModalDelete()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/memberPush/delete', {
        id: this.delId
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('刪除推播成功')
            this.getMemberPushesList(1)
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F36') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
    this.getCurrentTime()
    this.getMemberPushesList(1)
    this.LoginUserID = localStorage.getItem('LoginUserID')
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
#mytable > tbody > tr > td {
  vertical-align: middle;
}

.table-break {
  word-break: break-all;
  /* table-layout:fixed; */
}

.text-nowrap > th {
  white-space: nowrap;
}
.broder {
  border-color: #004f2d !important;
  border-style: solid !important;
  border-width: 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/member/memberPush/List.vue